<template>
  <a
    :href="pdfLinkUrl"
    class="u-reset cms-pdf-link file-link"
    rel="noopener noreferrer"
    target="_blank"
  >
    <div class="cms-pdf-link__icon">
      <responsive-img
        :width="40"
        alt=""
        class="cms-pdf-link__icon-image"
        src="/images/cms_components/pdf_file_small@3x.png"
      />
    </div>
    <span class="cms-pdf-link__text">
      {{ pdfLinkText }}
    </span>
    <div class="cms-pdf-link__arrow">
      <responsive-img
        :width="41"
        alt=""
        class="cms-pdf-link__arrow-image"
        src="/images/arrow_icons/custom/arrow_right_pos@3x.png"
      />
    </div>
  </a>
</template>

<script>
  import ResponsiveImg from '~/components/responsive-img/responsive-img'

  export default {
    components: { ResponsiveImg },
    props: {
      pdfLinkText: {
        type: String,
        required: true,
      },
      pdfLinkUrl: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss" src="./_cms-pdf-link.scss" />
